import { apiFetch } from '../../../lib/api/client'
import { useBookingStore } from '../../../store'
import type { BookingData } from '../Timeslots.types'

/**
 * Fetches an existing booking by the booking-id currently in the store.
 * Used by the reschedule / cancel deep-link flows.
 */
export async function getBooking(): Promise<BookingData> {
  const { bookingId } = useBookingStore.getState()
  if (!bookingId) {
    throw new Error('No booking ID provided')
  }
  return apiFetch<BookingData>(`booking/${bookingId}`)
}

export async function updateBooking(): Promise<{ id: string }> {
  const { bookingId, duration, timeslot } = useBookingStore.getState()

  return apiFetch<{ id: string }>('booking/update', {
    method: 'PUT',
    body: JSON.stringify({
      id: bookingId,
      duration,
      date: timeslot,
    }),
  })
}

export async function cancelBooking(): Promise<void> {
  const { bookingId } = useBookingStore.getState()
  return apiFetch<void>(`booking/cancel/${bookingId}`, { method: 'DELETE' })
}
